import './App.css';
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from './components/Home'
import Footer from './components/Footer';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import Navbar from './components/Navbar';
import Products from './components/Products';
import Contacts from './components/Contacts'
import Filters from './components/Filters';
import Meters from './components/Meters';
import Pumps from './components/Pumps';
import Membranes from './components/Membranes';
import Vessels from './components/Vessels'
import Filtermedia from './components/Filtermedia'
import Ro from './components/Ro'
function App() {
  return (
    <Router>
    <div className="App" >
      <div>
      <header className="App-header row ">

        <h6>
        <img src="images/jalistep/logo1.jpg" alt="" className='img' width={100} />
        </h6>
     
      <h4>
      
        JALISTEP INTERNATIONAL LTD

      </h4>
      </header>

      </div>
     
      <Navbar/>
      <Routes>
      <Route path='/' element={<Home/>}/>
      <Route path='/products' element={<Products/>}/>
      <Route path='/contacts' element={<Contacts/>}/>
      <Route path='/filters' element={<Filters/>}/>
      <Route path='/pumps' element={<Pumps/>}/>
      <Route path='/meters' element={<Meters/>}/>
      <Route path='/membranes' element={<Membranes/>}/>
      <Route path='/vessels' element={<Vessels/>}/>
      <Route path='/filtermedia' element={<Filtermedia/>}/>
      <Route path='/ro' element={<Ro/>}/>
      <Route path='/aboutus' element={<Home/>}/>
      </Routes>
      <hr />
      <hr />
      <Footer/>
    </div>
    </Router>
  );
}

export default App;
